import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-detalle-productos-recepcion',
  templateUrl: './detalle-productos-recepcion.component.html',
  styleUrl: './detalle-productos-recepcion.component.scss'
})
export class DetalleProductosRecepcionComponent {
 @Input() remito: any;

  constructor(public activeModal: NgbActiveModal) {}

  cerrar() {
    this.activeModal.dismiss();
  }

  totalNatural(producto: any): number {
    return (producto.detalleCisternas ?? []).reduce((acc, c) => acc + Number(c.volumen || 0), 0);
  }

  total15(producto: any): number {
    return (producto.detalleCisternas ?? []).reduce((acc, c) => acc + Number(c.volumen15 || 0), 0);
  }

}
